import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  display: inline-block;
  .team-name {
    font-weight: 500;
    margin: 0;
  }
  .dropdown-button {
    background-color: transparent;
    color: inherit;
    padding: 0;
    font-weight: 500;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    font-size: inherit;
  }
  .dropdown-arrow {
    margin-left: 5px;
    font-size: 10px;
  }

  .dropdown-content {
    display: none;
    position: absolute;
    background-color: #f9f9f9;
    min-width: 200px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    z-index: 1;
    border-radius: 4px;
    margin-top: 4px;
    left: 0;
    p {
      color: black;
      padding: 12px 16px;
      text-decoration: none;
      display: block;
      &:hover {
        background-color: #f1f1f1;
        cursor: pointer;
      }
    }
  }

  .dropdown-content.show {
    display: block;
  }
`;
